<template>
  <div
    v-if="active"
    class="fixed bottom-20 left-3 z-[60] flex items-center gap-2 rounded-full border border-amber-300 bg-amber-50/95 p-1.5 pl-3 text-xs font-medium text-amber-950 shadow-lg shadow-black/10 backdrop-blur sm:bottom-4 sm:left-4"
  >
    <span class="flex items-center gap-1.5 whitespace-nowrap">
      <span class="size-2 rounded-full bg-amber-500" />
      مشاهدهٔ مشتری
    </span>
    <UButton
      size="xs"
      color="warning"
      :loading="stopping"
      @click="stop"
    >
      بازگشت به پنل
    </UButton>
  </div>
</template>

<script setup lang="ts">
import { apiErrorMessage } from '~/utils/apiError'
import { useAuthStore } from '~/stores/useAuthStore'

const { session, fetch } = useUserSession()
await fetch()

const active = computed(() => Boolean(session.value?.impersonatedBy))
const stopping = ref(false)
const toast = useToast()

async function stop() {
  stopping.value = true
  try {
    const result = await $fetch<{ ok: boolean; returnTo?: string }>('/api/admin/impersonate/stop', { method: 'POST' })
    await fetch()
    const auth = useAuthStore()
    auth.reset()
    auth.hydrated = true
    await navigateTo(result.returnTo || '/admin')
  } catch (error) {
    toast.add({ title: 'خطا', description: apiErrorMessage(error), color: 'error' })
  } finally {
    stopping.value = false
  }
}
</script>
